<div class="row">
    <div class="col-sm-8 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">HR Trends</h3>
            </div>
            <div class="card-body">
                <div class="graph-container">
                    <!--<div>
                      <button ejs-button cssClass="e-info" (click)='export()' style="text-transform:none !important" id="togglebtn print">EXPORT</button>
                    </div>-->

                    <ejs-chart style='display:block;' [primaryXAxis]='primaryXAxis' [primaryYAxis]='primaryYAxis' [tooltip]="tooltip">
                        <e-series-collection>
                            <e-series  [dataSource]='data' type='StackingColumn' xName='x' yName='y' name='Addition Trends' width='2'> </e-series>
                            <e-series  [dataSource]='data1' type='StackingColumn' xName='x' yName='y' name='Attrition Trends' width='2'> </e-series>
                            <e-series  [dataSource]='data2' type='StackingColumn' xName='x' yName='y' name='Head Count' width='2'> </e-series>
                        </e-series-collection>
                    </ejs-chart>
                  </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Department Graph</h3>
            </div>
            <div class="card-body">
                <div class="p-3">
                    <ejs-accumulationchart>
                        <e-accumulation-series-collection>
                            <e-accumulation-series type = 'Pie' [dataSource]='departmentData' xName='name' yName='value' [dataLabel]='datalabel'></e-accumulation-series>
                        </e-accumulation-series-collection>
                    </ejs-accumulationchart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Designation Graph</h3>
            </div>
            <div class="card-body ">
                <div class="p-3">
                    <ejs-accumulationchart>
                        <e-accumulation-series-collection>
                            <e-accumulation-series type = 'Pie' [dataSource]='designationData' xName='name' yName='value' [dataLabel]='datalabel'></e-accumulation-series>
                        </e-accumulation-series-collection>
                    </ejs-accumulationchart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Location Graph</h3>
            </div>
            <div class="card-body">
                <div class="p-3">
                    <ejs-accumulationchart>
                        <e-accumulation-series-collection>
                            <e-accumulation-series type = 'Pie' [dataSource]='locationData' xName='name' yName='value' [dataLabel]='datalabel'></e-accumulation-series>
                        </e-accumulation-series-collection>
                    </ejs-accumulationchart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-4">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Age Graph</h3>
            </div>
            <div class="card-body">
                <div class="p-3">
                    <ejs-accumulationchart>
                        <e-accumulation-series-collection>
                            <e-accumulation-series type = 'Pie' [dataSource]='ageData' xName='name' yName='value' [dataLabel]='datalabel'></e-accumulation-series>
                        </e-accumulation-series-collection>
                    </ejs-accumulationchart>
                </div>
            </div>
        </div>
    </div>
    <div class="col-sm-12 mb-2">
        <div class="card h-100">
            <div class="card-header">
                <h3 class="h5">Comp-Off Details for all employees</h3>
            </div>
            <div class="card-body">
                <div class="row pt-3">
                    <form [formGroup]="employeeDetailsForm">
                      <div class="row m-0">
                        <div class="col-sm-2 col-md-6 col-lg-3 col-xl-3" style="margin-right: 5px;">
                          <div class="input">
                            <div class="input-item">
                                <input list="employeeList" formControlName="userId"
                                  placeholder="Select Employee" value="" onfocus="this.value=''"
                                  onchange="this.blur();" />
                                <datalist id="employeeList">
                                  <option [value]="item" *ngFor="let item of userDropdownList"></option>
                                </datalist>
                                <label class="floating-label">Employee Name</label>
                                <i class="ri-user-line"></i>
                            </div>
                          </div>
                        </div>     
                        <div class="col-sm-3 col-md-6 col-lg-3 col-xl-3 text-end text-right" style="margin-left: 5px;">
                          <button type="button" class="btn" (click)=getCompOffNotifications()>
                            <div>Submit</div>
                          </button>
                        </div>
                      </div>
                    </form>
                </div>
                <div class="card-body">
                    <div class="newBox">
                        <div *ngIf="compOffNotifications?.length > 0 ">
                          <span *ngFor="let item of compOffNotifications" style="margin-top: 10px;">
                            <i class="ri-calendar-check-line"></i> {{item.employeeName}} - Comp-Off applied for {{item.applicationDate}} will be valid until {{item.validityDate}}.
                            <br>
                          </span>
                        </div>
                    </div>
                    <div class="box">
                        <p class="text-center p-2" *ngIf="isNoData">No Comp-off expiring in next 7 days.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>